import { QuestionEditingOptions } from './question-editor.model';

export function isAnyEditingAllowed(config?: QuestionEditingOptions | null): boolean {
  if (!config) {
    return false;
  }

  const hasImageEditing = (config.allowImageEditing?.length ?? 0) > 0;
  const hasQuestionEditing = config.allowQuestionEditing ?? false;
  const hasMarkschemeEditing = config.allowMarkschemeEditing ?? false;

  return hasImageEditing || hasQuestionEditing || hasMarkschemeEditing;
}
